// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Products\Categories\DataProviders\ProductCategoryField
// Generated on: 2026-03-10 09:49:06

export enum ProductCategoryField {
  DB_TABLE = 'productCategories',
  DB_IDENTIFIER = 'categoryGUID',
  CATEGORY_NAME = 'categoryName',
  DESCRIPTION = 'description',
  TAG_LINE = 'tagLine',
  PARENT_CATEGORY_GUID = 'parentCategoryGUID',
  DISPLAY_ORDER = 'displayOrder',
  SLUG = 'categorySlug',
  HIDDEN = 'isHidden',
  SLAVE_META_TITLE = 'slaveMetaTitle',
  SLAVE_META_DESCRIPTION = 'slaveMetaDescription',
  SLAVE_META_KEYWORDS = 'slaveMetaKeywords',
}

export const ProductCategoryFieldGetEncryptionFields = [] as const;

export const ProductCategoryFieldCases = ["productCategories", "categoryGUID", "categoryName", "description", "tagLine", "parentCategoryGUID", "displayOrder", "categorySlug", "isHidden", "slaveMetaTitle", "slaveMetaDescription", "slaveMetaKeywords"] as const;
